// src/pages/Layout.jsx
import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Box, CssBaseline, Drawer, AppBar, Toolbar, Typography, Divider, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { ReactComponent as FAOLogo } from '../assets/logo/fao-logo-white-3lines-en.svg';
import { ReactComponent as SwalimLogo } from '../assets/logo/swalim.svg';

const drawerWidth = 240;

const Layout = () => {
  return (
    <Box sx={{ display: 'flex', backgroundColor: '#f0f4f8', minHeight: '100vh'}}>
        <CssBaseline />

        <AppBar position="fixed">
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {/* Left: Logo */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <FAOLogo height={40} />
                    <Divider orientation="vertical" sx={{
                        backgroundColor: 'white',
                        width: '1px',
                        height: 40,
                    }} />
                    <Box
                        sx={{
                            display: 'flex', flexDirection: 'column', justifyContent: 'center'
                        }}
                        >
                        <Typography variant="h5" color="white" lineHeight={1.2}>
                            Water Sources
                        </Typography>
                        <Typography variant="h5" color="white" lineHeight={1.2}>
                         Monitoring Dashboard
                        </Typography>
                    </Box>
                </Box>



                <Box sx={{ display: 'flex', alignItems: 'center', gap:2 }}>
                    <Button color="inherit" href="/">
                        Home
                    </Button>
                    <SwalimLogo height={40} />
                </Box>

            </Toolbar>
        </AppBar>


      <Box component="main" sx={{ flexGrow: 1, p: 9 }}>
        {/* <Toolbar /> */}
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;